import { useState, useEffect } from 'react';
import useBlockSelection from "/src/features/editor/hook/block/useBlockSelection"
import { useTreeStateContext } from "../../contexts/TreeContext";
import useCategories from './useCategories';
import { useCameraStateContext } from "../../contexts/CameraContext"
import useCamera from "/src/features/editor/hook/useCamera"
import binarySearchString from '../../utils/binarySearchString';
function useCategorySelection() {
    var blocksSelected = [];

    const { blocksVisible, blocks,categories } = useTreeStateContext();

    const { createCategory, addBlocksInCategory } = useCategories();

    const { panzone } = useCameraStateContext()

    const { getPosition } = useCamera();

    const [positionStartCategory, setPositionStartCategory] = useState({ x: 0, y: 0 })

    const { makeZoneSelection, updateZoneSelection, resetZoneSelection, deselectAllBlocks } = useBlockSelection();    

    const handleMouseDown = ({ buttons, clientX, clientY}) => {
        if (buttons != 2) return;

        makeZoneSelection(clientX, clientY);
        setPositionStartCategory({ x: clientX, y: clientY})   
    }

    const handleMouseMove = ({buttons,clientX,clientY}, positionStartCategory) => {

        if (buttons != 2 || panzone == null) return;

        let res = updateZoneSelection(clientX, clientY, getPosition(), positionStartCategory);
        if (res.length == blocksSelected.length) return;

        unselectOldBlocks(res, blocksSelected);
        blocksSelected = res;
        
    }

    const handleMouseUp = (e) => {
        let {button,clientX,clientY} = e;
        if (button == 2 && isInInterfaceArea(clientX,clientY) == false) { // right click up
            deselectAllBlocks(blocksSelected)
            resetZoneSelection()
            if (blocksSelected.length > 0) {
                createNewCategory()
            }
            blocksSelected = []
        }
        if (button == 0 && blocks.length > 0) {// left click up
            const clickedElements = document.elementsFromPoint(clientX, clientY);
            const isOnButton = clickedElements.some(element => element.tagName.toLowerCase() =="button");
            if (isOnButton) {
                return;
            }
            checkingMovement(clientX,clientY);
        }
        
    }

    const createNewCategory = async ()=>{
        let blocks_id = blocksSelected.map(block => block.id)
        createCategory(blocks_id)
    }


    const checkingMovement = (clientX,clientY) => {
        let elements = Array.from(document.querySelectorAll(".block.selected"));
        if (elements.length == 0) { // pas de mouvement de block
            return;
        }
        let listBlockSelected = elements.map(element => blocks[binarySearchString(blocks, element.id)]);
        let res = listBlockSelected.map(block => block.bot_category_id); // on recherche les blocks cliquees dans la liste, et on recupere leur category

        //on supprime les doublons des categories, dans le cas ou on selectionne differents block de la meme category
        res = res.filter((value, index, self) => { return value && self.indexOf(value) === index; }); // https://www.geeksforgeeks.org/how-to-remove-duplicate-elements-from-javascript-array/

        if (res.length == 0) { // pas besoin de modifier les categories dans ce cas 
            checkAddingBlocksInCategory(clientX,clientY, listBlockSelected);
            return;
        }
    }


    const checkAddingBlocksInCategory = async (clientX,clientY,listBlockSelected) => {
        let elements = document.elementsFromPoint(clientX, clientY)//.getElementsByClassName("category_container")//.forEach(el => el.matches(".category_container"));
        let category = elements.find((element) => element.classList.contains('category_container'));
        if (!category || isInInterfaceArea(clientX,clientY) == true) { // si pas de category la ou la souris se trouve, on s'arrete
            return;
        }
        let category_id = categories.find(c => c.category.object_id === category.id).category.id
        addBlocksInCategory(category_id,listBlockSelected)
    }
    const unselectOldBlocks = (newBlocks, oldBlocks) => {
        let blocksToDeselect = [];
        for (let i = 0; i < oldBlocks.length; i++) {
            let block = oldBlocks[i];
            let isFound = false
            for (let j = 0; j < newBlocks.length; j++) {
                if ( !(block.id === newBlocks[j].id)) continue;
                isFound = true;
            }
            if (isFound) continue;
            blocksToDeselect.push(block);
        }
        deselectAllBlocks(blocksToDeselect)
        return newBlocks
    }
    
    
    const handleRightClick = (e)=>{
        let {clientX, clientY} = e;
        if (isInInterfaceArea(clientX, clientY) == false){
            e.preventDefault();
            return;
        }
    }
    
    const isInInterfaceArea = (clientX, clientY)=>{
        var clickedElement = document.elementsFromPoint(clientX, clientY);
        clickedElement = clickedElement[0]?.id == "zone_blocks_selection" ? clickedElement[1].classList : clickedElement[0]?.classList
        if (clickedElement == undefined) return false;
        const isInInterface = ! (clickedElement.contains('camera') ||clickedElement.contains('block') || clickedElement.contains('category_container')) ; // .some(element => element.classList.contains('interface_editor'));
        return isInInterface;
    }

    useEffect(() => {
        const mouseDownHandler = handleMouseDown;

        document.addEventListener('mousedown', mouseDownHandler);
        return () => {
            document.removeEventListener('mousedown', mouseDownHandler);
        };
    }, [blocksVisible]);

    useEffect(() => {
        const mouseMoveHandler = (e) => handleMouseMove(e, positionStartCategory);
        const contextMenuHandler = (e) => handleRightClick(e);
        const mouseUpHandler = handleMouseUp;
    
        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('contextmenu', contextMenuHandler);
        document.addEventListener('mouseup', mouseUpHandler);
    
        return () => {
            document.removeEventListener('mousemove', mouseMoveHandler);
            document.removeEventListener('contextmenu', contextMenuHandler);
            document.removeEventListener('mouseup', mouseUpHandler);
        };

    }, [positionStartCategory, blocks])

    return null;
}

export default useCategorySelection;